<div
  class="attachments-form"
  #attachmentsForm="ngbPopover"
  [ngbPopover]="attachmentsFormTpl"
  [popoverClass]="'attachments-form__popover'"
  [placement]="placement"
  [container]="'body'"
  [autoClose]="'outside'"
  (shown)="files.removeAll(); isOpened$.next(true)"
  (hidden)="isOpened$.next(false)"
>
  <ng-content></ng-content>
</div>

<ng-template #attachmentsFormHeaderTpl>
  <div class="attachments-form__modal-header">
    <div class="attachments-form__modal-header-label">{{ title }}</div>
    <div class="attachments-form__modal-header-btn" (click)="attachmentsForm.close()">
      <i class="fa fa-times"></i>
    </div>
  </div>
</ng-template>

<ng-template #attachmentsFormTpl>
  <div class="attachments-form__modal">
    <ng-container [ngTemplateOutlet]="attachmentsFormHeaderTpl"></ng-container>
    <ng-container *ngIf="!(uploadResults$ | async); else attachmentsUploadResultsTpl">
      <div class="attachments-form__modal-content" [class.isSaving]="isSaving$ | async">
        <app-attachments-form-type-selector
          [disabled]="isSaving$ | async"
          (ready)="categorySelector = $event"
          [defaultValue]="showDefaultType && defaultType"
        >
        </app-attachments-form-type-selector>
        <div class="form-indent"></div>
        <app-attachments-form-uploader (filesAdded)="addFiles($event)"></app-attachments-form-uploader>
        <div class="form-indent"></div>
        <div class="attachments-form__modal-content-files">
          <ng-container *ngFor="let file of files.items; let i = index">
            <div class="form-indent" *ngIf="!!i"></div>
            <div class="form-indent"></div>
            <div class="attachments-form__modal-content-file-header">
              <div class="text-semibold">{{ file.name }}</div>
              <div class="attachments-form__modal-content-file-remove" (click)="files.remove(file)">
                <i class="fa fa-trash-o"></i>
              </div>
            </div>
            <div class="form-indent"></div>
            <app-attachments-form-editor [disabled]="isSaving$ | async" (valueChange)="updateFileDetails(file, $event)">
            </app-attachments-form-editor>
          </ng-container>
        </div>
        <div class="form-indent"></div>
      </div>
    </ng-container>
    <ng-container *ngIf="isSaving$ | async" [ngTemplateOutlet]="loader"></ng-container>
    <div class="attachments-form__modal-footer">
      <div class="attachments-form__modal-footer-label">
        <div *ngIf="!(uploadResults$ | async) && files.size as itemsQty">
          <div class="badge">{{ itemsQty }}</div>
          <span>&nbsp;&nbsp;File{{ itemsQty > 1 ? 's' : '' }}</span>
        </div>
      </div>
      <div class="attachments-form__modal-footer-buttons">
        <button class="btn btn-default" (click)="attachmentsForm.close()">
          <span>{{ (uploadResults$ | async) ? 'CLOSE' : 'CANCEL' }}</span>
        </button>
        <ng-container *ngIf="!(uploadResults$ | async)">
          <button
            class="btn btn-primary"
            [disabled]="
              !files.size || (categorySelector && !(categorySelector?.selected$ | async)) || (isSaving$ | async)
            "
            (click)="submitForm()"
          >
            <span>ATTACH{{ (isSaving$ | async) ? 'ING FILES..' : '' }}</span>
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #attachmentsUploadResultsTpl>
  <div class="attachments-form__modal-results">
    <ng-container *ngFor="let item of uploadResults$ | async">
      <div class="attachments-form__modal-result" [class.isFailed]="item.failed">
        <div class="attachments-form__modal-result-labels">
          <b>{{ item?.attachmentDto?.name || '' }}</b>
          <br />
          <ng-container *ngIf="item?.attachmentDto?.createdDate as createdDate">
            <small>{{ item.attachmentDto.createdDate | date : 'medium' }}</small>
          </ng-container>
        </div>
        <div class="attachments-form__modal-result-icons">
          <i
            class="fa fa-fw fa-{{ item.failed ? 'exclamation-triangle' : 'check' }}"
            [ngbTooltip]="item.message"
            tooltipClass="fade in tooltip-{{ item.failed ? 'danger' : 'success' }}"
            [openDelay]="500"
            placement="left"
          ></i>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #loader>
  <div class="attachments-form__loader">
    <app-loader-linear height="3px"></app-loader-linear>
  </div>
</ng-template>
